import React from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import useRouter from '../../../../hooks/useRouter';
import { StateType } from '../../../../states';
import useMissionComplexeStatus from '../../hooks/useMissionComplexeStatus';

import MissionDetailsAchievement from './MissionDetailsAchievement';
import selectMissionDetailsAchievementContainerProps from './MissionDetailsAchievement.selector';

type MissionDetailsAchievementContainerProps = {
  className?: string;
  missionId: number;
  achievementId: number;
};

const MissionDetailsAchievementContainer = (ownProps: MissionDetailsAchievementContainerProps) => {
  const { history } = useRouter();
  const dispatch = useDispatch();

  const { missionId, achievementId } = ownProps;

  const selectorProps = useMemo(
    () => ({ missionId, achievementId, history, dispatch }),
    [missionId, achievementId, history, dispatch],
  );

  const missionStatus = useMissionComplexeStatus(selectorProps);

  const selectedProps = useSelector((state: StateType) =>
    selectMissionDetailsAchievementContainerProps(state, selectorProps),
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <MissionDetailsAchievement {...enhancedProps} missionStatus={missionStatus} />;
};

export default MissionDetailsAchievementContainer;
